var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgForwardArrow(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "#40AFED",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M7.275 3.975l4.5 4.5c.15.15.225.3.225.525a.68.68 0 01-.225.525l-4.5 4.5c-.3.3-.75.3-1.05 0-.3-.3-.3-.75 0-1.05L10.2 9 6.225 5.025c-.3-.3-.3-.75 0-1.05.3-.3.75-.3 1.05 0z"
  })));
}
export default SvgForwardArrow;